import type { $Enums } from '@prisma/client'

export const musicModelMap: typeof import('@prisma/client').$Enums.MusicModel =
  {
    V1: 'V1',
    V2: 'V2',
    V3: 'V3',
    V4: 'V4',
  }

export interface IMusicModel {
  label: string
  value: $Enums.MusicModel
  iconClassName: string
}
export const musicModels: IMusicModel[] = [
  {
    label: 'Tad V1.0',
    value: musicModelMap.V1,
    iconClassName: 'i-cus--tad-logo-ico',
  },
  {
    label: 'Tad V2.0',
    value: musicModelMap.V2,
    iconClassName: 'i-cus--tad-logo-ico',
  },
  {
    label: 'Tad V3.0',
    value: musicModelMap.V3,
    iconClassName: 'i-cus--tad-logo-ico',
  },
  {
    label: 'Tad V4.0',
    value: musicModelMap.V4,
    iconClassName: 'i-cus--tad-logo-ico',
  },
]

export const taskTypeMap = {
  Song: 'Song',
  Instrumental: 'Instrumental',
  Vocal: 'Vocal',
  Cover: 'Cover',
} as const satisfies Record<string, $Enums.MusicGenerationTaskType | 'Cover'>

export const taskTypeOptions: {
  label: string
  value: $Enums.MusicGenerationTaskType
  iconClassName: string
}[] = [
  {
    label: 'Song',
    value: taskTypeMap.Song,
    iconClassName: 'i-cus--tad-music-note',
  },
  {
    label: 'Instrumental',
    value: taskTypeMap.Instrumental,
    iconClassName: 'i-cus--tad-instrumental',
  },
  {
    label: 'Vocal',
    value: taskTypeMap.Vocal,
    iconClassName: 'i-cus--tad-voice',
  },
]

export type TTaskTypeValue = $Enums.MusicGenerationTaskType

export const musicTypeMap = {
  Instrumental: 'Instrumental',
  Song: 'Song',
  Vocal: 'Vocal',
  Cover: 'Cover',
} as const satisfies Record<string, $Enums.MusicType | 'Cover'>

export interface IPromptSelectMode {
  label: string
  value: 'smart' | 'custom' | 'quick'
  iconClassName?: string
}

export const promptSelectModeOptions: IPromptSelectMode[] = [
  {
    label: 'Smart',
    value: 'smart',
  },
  {
    label: 'Quick',
    value: 'quick',
  },
]
